import React from 'react';
import { connect } from 'react-redux';
import FilterItem  from "../../../content/element/filter/filter-grid-2"
const Filter = props => {
    const { project } = props;    
    return (
        <div className="filter-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="filter-sort">
                            <ul id="card_filter">
                                <li data-uk-filter="" className="active"> All</li>
                                <li data-uk-filter="1"> Business Service</li>
                                <li data-uk-filter="2"> Financial Services</li> 
                                <li data-uk-filter="3"> Travel & Aviation</li>
                                <li data-uk-filter="4"> Academic Research</li>
                            </ul>
                        </div>{/*<!-- ends: .filter-sort -->*/}
                    </div>{/*<!-- ends: .col-lg-12 -->*/}
                </div>
                    <div className="row" data-uk-grid="{controls: '#card_filter'}">
                    {
                        Object.values(project).slice(0, 6).map((value, key) => {
                            const { id, imgSrc, category, title, subtitle, content } = value;
                            return (
                                <FilterItem 
                                    key={ id }
                                    id={ id }
                                    img={ imgSrc }
                                    category={ category }
                                    title={ title }
                                    subtitle={ subtitle }
                                    content={content}

                                />
                            )
                        })
                    }
                    </div>
            </div>
        </div>
    )
}
const mapStateToProps = state => {
    return {
        project : state.project
    }
}
export default connect(mapStateToProps)(Filter);